import { Controller } from "@hotwired/stimulus"
import { showToast } from "../utils/show_toast"

export default class extends Controller {
  static values = {
    url: String
  }

  async share(event) {
    event.preventDefault()
    if (!this.hasUrlValue || !this.urlValue) {
      showToast("Could not copy link", "error")
      return
    }

    try {
      await navigator.clipboard.writeText(this.urlValue)
      showToast("Link copied")
    } catch (_error) {
      showToast("Could not copy link", "error")
    }
  }
}
